(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ext/dhtmlxgantt_auto_scheduling", [], factory);
	else if(typeof exports === 'object')
		exports["ext/dhtmlxgantt_auto_scheduling"] = factory();
	else
		root["ext/dhtmlxgantt_auto_scheduling"] = factory();
})(window, function() {
return 